import { useState, useEffect } from "react";

const InputOptions = ({
    title,
    subtitle,
    defaultValue,
    options = [],
    onChangeValue,
    className = "",
    disabled = false,
    // Props de compatibilidad hacia atrás
    minValue,
    maxValue,
}) => {
    // Generar opciones automáticamente si se usan las props legacy (minValue, maxValue)
    const finalOptions =
        options.length > 0
            ? options
            : [
                  { value: minValue, label: minValue?.toString() || "25" },
                  { value: maxValue, label: maxValue?.toString() || "37" },
              ];

    const [currentValue, setCurrentValue] = useState(() => {
        if (defaultValue !== undefined) return defaultValue;
        return finalOptions[0]?.value || 0;
    });

    useEffect(() => {
        const newValue = defaultValue !== undefined ? defaultValue : finalOptions[0]?.value || 0;
        setCurrentValue(newValue);
    }, [defaultValue, finalOptions]);

    const changeValue = (value) => {
        if (disabled) return;
        setCurrentValue(value);
        onChangeValue(value);
    };

    return (
        <div className={`input-range-container input-options-container ${className}`}>
            {title && <h2>{title}</h2>}
            {subtitle && <p>{subtitle}</p>}
            <div className="input-options-body">
                {finalOptions.map((option, index) => (
                    <div
                        key={option.value || index}
                        className={`item-box ${currentValue === option.value ? "active" : ""} ${
                            disabled ? "disabled" : ""
                        }`}
                        onClick={() => changeValue(option.value)}
                    >
                        <span>{option.label}</span>
                        {option.description && <small>{option.description}</small>}
                    </div>
                ))}
            </div>
        </div>
    );
};

InputOptions.defaultProps = {
    title: "",
    subtitle: "",
    defaultValue: undefined,
    options: [],
    onChangeValue: () => {},
    className: "",
    disabled: false,
    // Props legacy para compatibilidad hacia atrás
    minValue: 25,
    maxValue: 37,
};

export default InputOptions;

/**
 * Ejemplos de uso:
 *
 * // Uso básico con opciones personalizadas
 * <InputOptions
 *   title="Selecciona una opción"
 *   subtitle="Elige la mejor opción para ti"
 *   options={[
 *     { value: 1, label: "Opción 1" },
 *     { value: 2, label: "Opción 2" },
 *     { value: 3, label: "Opción 3" }
 *   ]}
 *   defaultValue={2}
 *   onChangeValue={(value) => console.log(value)}
 * />
 *
 * // Opciones con descripciones
 * <InputOptions
 *   title="Planes de financiamiento"
 *   options={[
 *     { value: 12, label: "12 meses", description: "Sin interés" },
 *     { value: 24, label: "24 meses", description: "Interés bajo" },
 *     { value: 36, label: "36 meses", description: "Cuotas menores" }
 *   ]}
 *   onChangeValue={setPlan}
 * />
 *
 * // Compatibilidad hacia atrás (funciona igual que antes)
 * <InputOptions
 *   title="Rango de edad"
 *   minValue={25}
 *   maxValue={37}
 *   defaultValue={25}
 *   onChangeValue={setAge}
 * />
 *
 * // Con estilos y estado deshabilitado
 * <InputOptions
 *   title="Opciones premium"
 *   className="premium-options"
 *   disabled={!isPremiumUser}
 *   options={premiumOptions}
 *   onChangeValue={handlePremiumChange}
 * />
 */